import {
    CREATE_PALLET_RECEIVE,
    DELETE_PALLET_RECEIVE,
    GET_PALLET_RECEIVE,
    PALLET_RECEIVE_REQUEST,
    PALLET_RECEIVE_REQUEST_FAILURE,
    UPDATE_PALLET_RECEIVE,
    GET_PALLET_RECEIVES_PAGE,
    PALLET_RECEIVE_REQUEST_SUCCESS,
  } from "../types/pallet-receive-types";
  
  const initialState = {
    palletReceive: [],
    palletReceivesPage: [],
    availableTransactions: [],
    loading: false,
    error: null,
  };
  
  const palletReceiveReducer = (state = initialState, action) => {
    switch (action.type) {
      case PALLET_RECEIVE_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        }
      }
      case GET_PALLET_RECEIVE: {
        return {
          ...state,
          palletReceive: [...action.payload],
          loading: false,
          error: null
        }
      }
      case GET_PALLET_RECEIVES_PAGE: {
        const { data, total, page, pageSize, search, where } = action.payload || {};
        return {
          ...state,
          palletReceivesPage: [...data],
          total,
          page,
          pageSize,
          search: search || '',
          where: where || {},
          loading: false,
          error: null
        }
      }
      case CREATE_PALLET_RECEIVE:
        return {
          ...state,
          palletReceive: [action.payload, ...state.palletReceive],
          loading: false,
          error: null
        };
      case UPDATE_PALLET_RECEIVE:
        const palletReceiveData = state.palletReceive.slice(0);
        const uIndex = palletReceiveData.findIndex((data) => data.id === action.payload.id);
        palletReceiveData.splice(uIndex, 1, { ...action.payload.data });
        
        return {
          ...state,
          palletReceive: [ ...palletReceiveData ],
          loading: false,
          error: null
        };
      case DELETE_PALLET_RECEIVE:
        const palletReceive = state.palletReceive?.slice(0);
        const index = palletReceive.findIndex((data) => data.id === action.id);
        if (index > -1) {
          palletReceive.splice(index, 1);
        }
        return {
          ...state,
          palletReceive: [...palletReceive],
          loading: false,
          error: null
        }
      case PALLET_RECEIVE_REQUEST_SUCCESS: {
        return {
          ...state,
          loading: false,
          error: null
        }
      }
      case PALLET_RECEIVE_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        }
      }
      default:
        return state;
    }
  };
  
  export default palletReceiveReducer;
  